import React from 'react';
import {Link} from 'react-router-dom';
import footerLogo from '../assets/images/footer-logo.png';
import '../assets/styles/style.css';
import rightArrow from '../assets/images/right-arrow-50.png';
import {useTranslation} from "react-i18next";
import dompurify from "dompurify";

const Footer = () => {
    const {t} = useTranslation("footer");
    return (
        <footer className="footer">
            <div className="container">
                <div className="flex flex-col md:flex-row justify-between items-center md:items-end py-4 md:py-10">
                    <div className="w-2/5">
                        <a href="/">
                            <img src={footerLogo} className="" alt="footer logo"/>
                        </a>
                    </div>
                    <div className="mt-8 md:mt-0">
                        <ul>
                            <li className="inline-block mr-6">
                                <a href="mailto:sales@blueshine.com.au">
                                    <p className="inline-block border-b border-white text-white text-base md:text-lg font-primary">{t('footer:messageUs')}</p>
                                    <img className={"img-icon"} src={rightArrow} height={40} width={30}/>
                                </a>
                            </li>
                            <li className="inline-block ">
                                <a href="tel:+61 03 9833 4890">
                                    <p className="inline-block border-b border-white text-white text-base md:text-lg font-primary">{t('footer:callUs')}</p>
                                    <img className={"img-icon"} src={rightArrow} height={40} width={30}/>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={"footer-grid"}>
                    <div className="footer-col">
                        <h2>{t('footer:aboutUs')}</h2>
                        <ul>
                            <li><Link to="/company-info">{t('footer:btn_company_info')}</Link></li>
                            <li><Link to="/company-vision">{t('footer:btn_company_vision')}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h2>{t('footer:service')}</h2>
                        <ul>
                            <li><Link to="/services">{t('footer:btn_our_service')}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h2>{t('footer:eventNew')}</h2>
                        <ul>
                            <li><Link to="/news">{t('footer:btn_news_event')}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h2>{t('contact:contact')}</h2>
                        <p>{t('contact:address')}</p>
                        {/*<p>{t('contact:phone')}</p>*/}
                        <p>{t('contact:abn')}</p>
                        <div className={`description-highlight font-bold text-white`}
                             dangerouslySetInnerHTML={{__html: dompurify.sanitize(t('contact:email'))}}/>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Blueshine. All rights reserved.</p>
                <div className="social-links">
                    <a href="#"><i className="fab fa-facebook"></i></a>
                    <a href="#"><i className="fab fa-twitter"></i></a>
                    <a href="#"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            {/*</div>*/}
        </footer>
    );
};

export default Footer;